<template lang="pug">
.wt-user-card
  template(v-if="!isProfile")
    UserCardActionsMenu(:isLinkToProfile="true")
  template(v-else-if="friendsLoaded && isFriends")
      UserCardActionsMenu(:friend="data")
  .columns.is-multiline.is-mobile
    .column.is-narrow
      RouterLink(v-if="!isProfile" to="member-settings/profile")
        EntityAvatar(:image="data.avatar || ''" is-rounded)
      EntityAvatar(v-else :image="data.avatar || ''")
    .column.is-narrow
      .is-size-3.has-text-weight-semiboldy(v-if="data.name && data.name.length > 0") {{ data.name }}
      .is-size-6.has-text-grey(v-if="data.location && data.location.length > 0") Location: {{ data.location }}
      WtRouterLink.view-public-profile(
        v-if="$router.currentRoute.name !== 'ProfilePage' && _.get(data, 'username', false)"
        to="ProfilePage"
        underlined
        :params="{ username: data.username }"
        text="View Public Profile"
      )
  .wt-user-card-body
    .is-flex.mb-5.is-flex-wrap-wrap
      .member-since.mr-3
        .is-size-7.has-text-grey Member Since:
        .is-size-6 {{ registeredDate }}
      .last-visit
        .is-size-7.has-text-grey Last Visit:
        .is-size-6 {{ lastVisitDate }}

    .badges(v-if="_.get(data, 'program.badges', coreProgramMeta.badges)")
      WtTitle.wt-badges-title(card-title).mb-4 {{data.username !== $auth.user().username ? 'Badges ' : 'My Badges '}}( {{ badges.length }} )
      WtRouterLink.is-size-7.wt-badges-view-all(
        v-if="_.get(data, 'username', false)"
        :to="BadgesPageRoute"
        :params="{ username: data.username }"
      ) View All

      .columns.is-mobile.is-multiline(v-if="badges.length > 0")
        WtBadge.column.is-one-fifth.p-1(v-for="badge in badges.slice(0,5) " :key="badge.id" :badge="badge")
      .empty-state(v-else) {{data.username !== $auth.user().username ? '' : "You haven't earned any badges yet!"}}



</template>

<script>
import WtBadge from "@@/WtBadge/WtBadge";
import WtButton from "@@/WtButton/WtButton";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";
import WtTitle from "@@/WtTitle/WtTitle";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import EntityAvatar from "@@/WtEntityAvatar/WtEntityAvatar";
import UserCardActionsMenu from "@@/Members/UserCardActionsMenu";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "UserCard",

  components: {
    EntityAvatar,
    WtBadge,
    WtButton,
    WtRouterLink,
    WtTitle,
    UserCardActionsMenu
  },

  mixins: [dateUtilityMixin],

  props: {
    data: {
      type: Object,
      required: true
    },

    isProfile: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      badges: []
    };
  },

  computed: {
    ...mapGetters("members", ["memberFriends", "friendsLoaded"]),
    ...mapGetters("program", ["coreProgramMeta"]),

    BadgesPageRoute() {
      return this.$route.name === "MyDashboard"
        ? "BadgesPage"
        : "ProfileBadgesPage";
    },

    deviceText() {
      let deviceApi = this._.get(this.data, "deviceApi", false);
      deviceApi = deviceApi.toString().toLowerCase();
      let deviceName = null;

      if (deviceApi) {
        if (deviceApi === "googlefit") {
          deviceName = "Google Fit";
        }
        if (deviceApi === "healthconnect") {
          deviceName = "Health Connect";
        }
        if (deviceApi === "healthkit") {
          deviceName = "Apple Health";
        }
        if (deviceApi === "garmin") {
          deviceName = "Garmin";
        }
        if (deviceApi === "samsunghealth") {
          deviceName = "Samsung Health";
        }
        if (deviceApi === "fitbit") {
          // get the device type
          deviceName = this._.get(
            this.data,
            "externalDevice.deviceName",
            "Fitbit"
          );
        }
      }
      if (deviceName) {
        return this.isProfile ? "Connected" : this._.upperFirst(deviceName);
      } else {
        return this.isProfile ? "Not Connected" : "CONNECT A DEVICE";
      }
    },

    registeredDate() {
      return this.data.registeredDate
        ? this.unixDateTime(this.data.registeredDate, "DATE_FORMAT_SHORT_MONTH")
            .formatted
        : "";
    },

    lastVisitDate() {
      return this.data.lastVisitDate
        ? this.unixDateTime(this.data.lastVisitDate).formatted
        : "";
    },

    isFriends() {
      if (this.memberId === this.$auth.user().id) return false;
      return (
        this._.findIndex(this.memberFriends, {
          id: this.memberId
        }) > -1
      );
    },

    memberId() {
      return this._.get(this.data, "id", false);
    }
  },

  watch: {
    memberId: {
      // needed for profile page to refetch them badgers
      handler: function(memberId) {
        if (memberId) {
          this.getMemberBadges();
        }
      },
      immediate: true
    }
  },

  methods: {
    ...mapActions("members", ["fetchMemberBadges"]),

    async getMemberBadges() {
      if (this.memberId) {
        let result = await this.fetchMemberBadges(this.memberId);
        this.badges = result.data.data;
      }
    }
  }
};
</script>

<style lang="sass" scoped>
.wt-user-card
  .wt-user-card-body
    margin: .6rem 0 .6rem 0
    .device
      .level
        margin-bottom: 0
    .member-since
      flex-basis: 100px
    .last-visit
      flex-basis: 200px
  .device-button
    margin: 5px 0

  .badges
    position: relative
    margin: 20px 0
    .wt-badges-view-all
      position: absolute
      top: 0
      right: 0
</style>
